import { createServiceHTTPClientProvider, createBoundServiceQueryHooksCreator, createBoundServiceMutationHookCreator } from "@airhelp/service-utils";
import { b as fetchOffers, d as fetchFeatureFlags, h as fetchLounges, a1 as fetchJourney, a3 as fetchJourneys, a5 as fetchCheckDeletableJourney, a7 as deleteJourney, aa as updateJourney, ah as addJourney, x as postPromoCode, ak as cancelMembership, ao as fetchTrip, k as fetchAirPayoutJourneys, o as fetchAirLuggageJourneys, u as updateAirPayoutJourneys, q as updateAirLuggageJourneys, t as triggerAirPayoutJourneys, p as triggerAirLuggageJourneys, r as uploadAirBundleDocument, s as createVerificationSession, ap as fetchBillingManagement, at as updateBillingAddress, av as updateCreditCard } from "./update-credit-card-Da4lxlNz.js";
import { useQueryClient } from "@tanstack/react-query";
const [AhPlusHTTPClientProvider, useAhPlusHTTPClient] = createServiceHTTPClientProvider({
  name: "AhPlus"
});
const AH_PLUS_REACT_QUERY_KEY_PREFIX = "ah-plus";
const createAhPlusQueryHooks = createBoundServiceQueryHooksCreator({
  queryKeyPrefix: AH_PLUS_REACT_QUERY_KEY_PREFIX,
  useClient: useAhPlusHTTPClient
});
const createAhPlusMutationHook = createBoundServiceMutationHookCreator({
  useClient: useAhPlusHTTPClient
});
const [useOffers, useOffersSuspense] = createAhPlusQueryHooks({
  queryFn: fetchOffers,
  queryKey: ["offers"]
});
const [useFeatureFlags, useFeatureFlagsSuspense] = createAhPlusQueryHooks({
  queryFn: fetchFeatureFlags,
  queryKey: ["feature-flags"]
});
const [useLounges, useLoungesSuspense] = createAhPlusQueryHooks({
  queryFn: fetchLounges,
  queryKey: ["lounges"]
});
const [useJourney, useJourneySuspense] = createAhPlusQueryHooks({
  queryFn: fetchJourney,
  queryKey: ["journey"]
});
const [useJourneys, useJourneysSuspense] = createAhPlusQueryHooks({
  queryFn: fetchJourneys,
  queryKey: ["journeys"]
});
const [useCheckDeletableJourney, useCheckDeletableJourneySuspense] = createAhPlusQueryHooks({
  queryFn: fetchCheckDeletableJourney,
  queryKey: ["journey", "check-deletable-journey"]
});
const useInternalDeleteJourney = createAhPlusMutationHook({
  mutationFn: deleteJourney
});
function useDeleteJourney(options) {
  const queryClient = useQueryClient();
  return useInternalDeleteJourney({
    async onSuccess(data, params, context) {
      var _a;
      await queryClient.invalidateQueries({
        queryKey: useJourneys.getQueryKey()
      });
      queryClient.removeQueries({
        queryKey: useJourney.getQueryKey({
          params
        })
      });
      await ((_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context));
    }
  });
}
const useInternalUpdateJourney = createAhPlusMutationHook({
  mutationFn: updateJourney
});
function useUpdateJourney(options) {
  const queryClient = useQueryClient();
  return useInternalUpdateJourney({
    async onSuccess(data, params, context) {
      var _a;
      await queryClient.setQueryData(
        useJourney.getQueryKey({ params: { id: data.id } }),
        { ...data }
      );
      await queryClient.invalidateQueries({
        queryKey: useJourneys.getQueryKey()
      });
      await ((_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context));
    }
  });
}
const useInternalAddJourney = createAhPlusMutationHook({
  mutationFn: addJourney
});
function useAddJourney(options) {
  const queryClient = useQueryClient();
  return useInternalAddJourney({
    async onSuccess(data, params, context) {
      var _a;
      await queryClient.invalidateQueries({
        queryKey: useJourneys.getQueryKey()
      });
      await ((_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context));
    }
  });
}
const useApplyPromoCode = createAhPlusMutationHook({
  mutationFn: postPromoCode
});
const useCancelMembership = createAhPlusMutationHook({
  mutationFn: cancelMembership
});
const [useTrip, useTripSuspense] = createAhPlusQueryHooks({
  queryFn: fetchTrip,
  queryKey: ["trip"]
});
const [useAirPayoutJourneys, useAirPayoutJourneysSuspense] = createAhPlusQueryHooks({
  queryFn: fetchAirPayoutJourneys,
  queryKey: ["journey", "air-payouts"]
});
const [useAirLuggageJourneys, useAirLuggageJourneysSuspense] = createAhPlusQueryHooks({
  queryFn: fetchAirLuggageJourneys,
  queryKey: ["journey", "air-luggages"]
});
const useInternalUpdateAirPayoutJourneys = createAhPlusMutationHook({
  mutationFn: updateAirPayoutJourneys
});
function useUpdateAirPayoutJourneys(options) {
  const queryClient = useQueryClient();
  return useInternalUpdateAirPayoutJourneys({
    async onSuccess(data, params, context) {
      var _a;
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: useJourneys.getQueryKey()
        }),
        queryClient.invalidateQueries({
          queryKey: useAirPayoutJourneys.getQueryKey({
            params: { journeyId: params.journeyId }
          })
        }),
        queryClient.setQueryData(
          useJourney.getQueryKey({ params: { id: params.journeyId } }),
          data
        )
      ]);
      (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context);
    }
  });
}
const useInternalUpdateAirLuggageJourneys = createAhPlusMutationHook({
  mutationFn: updateAirLuggageJourneys
});
function useUpdateAirLuggageJourneys(options) {
  const queryClient = useQueryClient();
  return useInternalUpdateAirLuggageJourneys({
    async onSuccess(data, params, context) {
      var _a;
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: useJourneys.getQueryKey()
        }),
        queryClient.invalidateQueries({
          queryKey: useAirLuggageJourneys.getQueryKey({
            params: { journeyId: params.journeyId }
          })
        }),
        queryClient.setQueryData(
          useJourney.getQueryKey({ params: { id: params.journeyId } }),
          data
        )
      ]);
      (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context);
    }
  });
}
const useInternalTriggerAirPayoutJourney = createAhPlusMutationHook({
  mutationFn: triggerAirPayoutJourneys
});
function useTriggerAirPayoutJourneys(options) {
  const queryClient = useQueryClient();
  return useInternalTriggerAirPayoutJourney({
    async onSuccess(data, params, context) {
      var _a;
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: useJourney.getQueryKey({
            params: { id: params.journeyId }
          })
        }),
        queryClient.invalidateQueries({
          queryKey: useAirPayoutJourneys.getQueryKey({
            params: { journeyId: params.journeyId }
          })
        }),
        queryClient.setQueryData(
          useJourney.getQueryKey({ params: { id: params.journeyId } }),
          data
        )
      ]);
      (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context);
    }
  });
}
const useInternalTriggerAirluggageJourney = createAhPlusMutationHook({
  mutationFn: triggerAirLuggageJourneys
});
function useTriggerAirLuggageJourneys(options) {
  const queryClient = useQueryClient();
  return useInternalTriggerAirluggageJourney({
    async onSuccess(data, params, context) {
      var _a;
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: useJourney.getQueryKey({
            params: { id: params.journeyId }
          })
        }),
        queryClient.invalidateQueries({
          queryKey: useAirLuggageJourneys.getQueryKey({
            params: { journeyId: params.journeyId }
          })
        }),
        queryClient.setQueryData(
          useJourney.getQueryKey({ params: { id: params.journeyId } }),
          data
        )
      ]);
      (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context);
    }
  });
}
const useUploadAirBundleDocument = createAhPlusMutationHook({
  mutationFn: uploadAirBundleDocument
});
const useCreateVerificationSession = createAhPlusMutationHook({
  mutationFn: createVerificationSession
});
const [useBillingManagement, useBillingManagementSuspense] = createAhPlusQueryHooks({
  queryFn: fetchBillingManagement,
  queryKey: ["billing-management"]
});
const useInternalUpdateBillingAddress = createAhPlusMutationHook({
  mutationFn: updateBillingAddress
});
function useUpdateBillingAddress(options) {
  const queryClient = useQueryClient();
  return useInternalUpdateBillingAddress({
    async onSuccess(data, params, context) {
      var _a;
      await queryClient.setQueryData(
        useBillingManagement.getQueryKey(),
        (current) => ({
          ...current,
          billingAddress: params.payload
        })
      );
      await queryClient.invalidateQueries({
        queryKey: useBillingManagement.getQueryKey()
      });
      await ((_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data, params, context));
    }
  });
}
const useUpdateCreditCard = createAhPlusMutationHook({
  mutationFn: updateCreditCard
});
export {
  AH_PLUS_REACT_QUERY_KEY_PREFIX,
  AhPlusHTTPClientProvider,
  useAddJourney,
  useAhPlusHTTPClient,
  useAirLuggageJourneys,
  useAirLuggageJourneysSuspense,
  useAirPayoutJourneys,
  useAirPayoutJourneysSuspense,
  useApplyPromoCode,
  useBillingManagement,
  useBillingManagementSuspense,
  useCancelMembership,
  useCheckDeletableJourney,
  useCheckDeletableJourneySuspense,
  useCreateVerificationSession,
  useDeleteJourney,
  useFeatureFlags,
  useFeatureFlagsSuspense,
  useJourney,
  useJourneySuspense,
  useJourneys,
  useJourneysSuspense,
  useLounges,
  useLoungesSuspense,
  useOffers,
  useOffersSuspense,
  useTriggerAirLuggageJourneys,
  useTriggerAirPayoutJourneys,
  useTrip,
  useTripSuspense,
  useUpdateAirLuggageJourneys,
  useUpdateAirPayoutJourneys,
  useUpdateBillingAddress,
  useUpdateCreditCard,
  useUpdateJourney,
  useUploadAirBundleDocument
};
//# sourceMappingURL=react.js.map
